export default {
  title: 'Delivered by',
  text: 'Our partnership with Uber and Foodamigos allows us to offer delivery directly through our website, <strong>saving us {{savings}} in delivery commissions</strong> per order compared to other platforms  Help us keep costs down and enjoy the best value by ordering here',
};